import { Pipe, PipeTransform } from '@angular/core';
import { ContentService } from '../../services/content/content.service';
import { Models } from '@ibexfusion/models';

@Pipe({
  name: 'importantNumbersPipe'
})
export class ImportantNumbersPipe implements PipeTransform {

  constructor(
    private contentService: ContentService
  ) {
  }

  transform(entry: Models.ContentEntry): Models.ImportantNumbersEntry | Models.ImportantNumbersEntry[] {
    if (!entry || (!entry.files && !entry.title && (!entry.detail || Object.keys(entry.detail).length === 0))) {
      return null;
    }

    if (!this.contentService.isValid(entry)) {
      return null;
    }

    if (entry.related && entry.related.entries && entry.related.entries.length > 0) {
      const entries: Models.ImportantNumbersEntry[] = [];

      for (const item of entry.related.entries) {
        const contentEntry = this.contentService.getEntry(item.id);
        const transformed = this.transform(contentEntry) as Models.ImportantNumbersEntry;
        if (transformed) {
          entries.push(transformed);
        }
      }
      return entries.length === 0 ? null : entries;
    }

    const importantNumbersEntry: any = new Models.ImportantNumbersEntry();
    let phone = entry.detail.phone;
    let website = entry.detail.website;
    let email = entry.detail.email;
    if (entry?.detail?.contact) {
      for (let contact of entry.detail.contact) {
        for (let variant of contact.variants) {
          if (!phone && variant.type === 'phone') {
            phone = variant.value;
          }
          if (!website && variant.type === 'website') {
            website = variant.value;
          }
          if (!email && variant.type === 'email') {
            email = variant.value;
          }
        }
      }
    }
    importantNumbersEntry.populateFromJSON({
      sourceId: entry._id, title: entry.title, website, phone, email,
      description: entry.detail && entry.detail.description ? entry.detail.description : null
    });

    return importantNumbersEntry;
  }
}
